var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<page>\n  <page-header>\n    <h1>\n      <div class=\"date\"><span class=\"header-icon deliverytimes\"></span>{{ t('settingsCompanyZipIntervalsTitle', settings.companyName) }}</div>\n    </h1>\n  </page-header>\n  <main>\n    <p style=\"margin: 30px 0 40px\">{{ t('settingsCompanyZipIntervalsDescription') }}</p>\n    <div ng-if=\"settings.zipIntervals.length == 0\" class=\"settingMissing\">{{ t('settingsMissingZipIntervals') }}</div>\n    <table ng-if=\"settings.zipIntervals.length &gt; 0\">\n      <thead>\n        <tr>\n          <th colspan=\"2\">{{ t('settingsZipIntervalsColInterval') }}</th>\n          <th>{{ t('settingsZipIntervalsColCustomerSystem') }}</th>\n          <th>{{ t('settingsZipIntervalsColTime') }}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"zipInterval in settings.zipIntervals\">\n          <td>{{ zipInterval.zipFrom }}</td>\n          <td>{{ zipInterval.zipTo }}</td>\n          <td>{{ zipInterval.customerSystemName }}</td>\n          <td>{{ zipInterval.seconds | durationSeconds }}</td>\n        </tr>\n      </tbody>\n    </table>\n  </main>\n</page>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/pages/settings/companyDeliveryTimes.jade
 ** module id = 54
 ** module chunks = 1
 **/